// extracted by mini-css-extract-plugin
module.exports = {"container":"GradinetContainer_container__z5J18","gradient":"GradinetContainer_gradient__6LBFJ"};